module.exports = __webpack_public_path__ + "static/media/navbar-logo.f25f845d.svg";